import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { Accordion as AccordionBase } from "@/v2-ui/accordion/base/AccordionBase"

export type AccordionProps = ComponentProps<typeof AccordionBase>

function Accordion(props: AccordionProps) {
  const { className, ...accordionBaseProps } = props
  return (
    <AccordionBase
      className={cn("ui-accordion", className)}
      {...accordionBaseProps}
    />
  )
}

export default Accordion
